module.exports = __webpack_public_path__ + "img/magento-custom-development.dc8e78e6.jpeg";